export default __webpack_public_path__ + "static/media/info-purple.2e46c4ae.svg";